import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69e77ef063911b00142217d8_1780927938162_b98b800e/netwatch/src/app/network-monitoring-dashboard/page.tsx");
